//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useContext } from 'react';
// import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getFormattedMessageDate, getUserDateFormat } from '../../common/dateHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import { AppContext } from '../../common/contexts';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            marginBottom: '24px',
        },
        messagesDateContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        //chatRightBlock2In h5:before
        line: { flexGrow: 1, background: '#f1f2f6', height: '1px' },
        //chatRightBlock2In h5
        messagesDateText: {
            textTransform: 'uppercase',
            letterSpacing: 0,
            margin: '0 18px 0 18px',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props, userDateFormat } = params;
    const { messageDate } = props;

    const messageDateText = getFormattedMessageDate(messageDate, userDateFormat);

    const defns = {
        messagesDateText: {
            variant: 'caption',
            clsLightBold: true,
            value: messageDateText, //"Tuesday, June 4, 2019"
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const MessagesDate = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const appContext = useContext(AppContext);
    const userDateFormat = getUserDateFormat(appContext);

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, userDateFormat });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.messagesDateContainer}>
                <div {...defns.line} />
                <AfitdTypography {...defns.messagesDateText} />
                <div {...defns.line} />
            </div>
        </div>
    );
};

export default MessagesDate;
